<section *ngIf="popupDataFiltered && showPopup">
  <div class="dialog">
    <div class="topbar">
      <h1 class="title heading-01-bold">{{ popupDataFiltered.title }}</h1>
      <qr-button
        *ngIf="popupDataFiltered.closeable"
        class="button-close"
        [config]="buttonClose"
        (click)="close()"
        matTooltip="Cerrar"
      ></qr-button>
    </div>

    <!-- Contenido dinámico -->
    <div class="content paragraph-01-regular">
      <!-- Message -->
      <div id="message" [innerHTML]="popupDataFiltered.message"></div>
      <!-- Image -->
      <div id="image" *ngIf="isImage">
        <img
          [src]="popupDataFiltered.image"
          (error)="this.utils.manageErrorImage($event)"
        />
      </div>
      <!-- Video -->
      <div id="video" *ngIf="isVideo">
        <video autoplay controls muted>
          <source [src]="popupDataFiltered.video" type="video/mp4" />
        </video>
      </div>
      <!-- video youtube -->
      <div id="video" *ngIf="isVideoUrl">
        <iframe
          [src]="popupDataFiltered.video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          autoplay="true"
          frameborder="0"
        ></iframe>
      </div>

      <!-- Note -->
      <div
        id="note"
        class="paragraph-02-regular"
        *ngIf="popupDataFiltered.note"
      >
        <b>Nota: </b>
        <br />
        <span [innerHTML]="popupDataFiltered.note"></span>
      </div>
    </div>

    <!-- Botones -->
    <div class="botbar" *ngIf="actionButtons">
      <div class="botbar-actions">
        <qr-button
          [config]="buttonCancel"
          (click)="close()"
          class="button-cancel"
        ></qr-button>

        <qr-button
          [config]="buttonAction"
          (click)="action()"
          class="button-action"
        ></qr-button>
      </div>
    </div>
    <div class="angryBotbar" *ngIf="!this.popupDataFiltered.closeable">
      <qr-button
        [config]="buttonLogout"
        (click)="logout()"
        class="button-cancel"
      ></qr-button>
    </div>
  </div>

  <div class="shadow" (click)="close()"></div>
</section>
